module.exports = __webpack_public_path__ + "static/media/retention_charts.6e48a8b0.png";